import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { ACCOUNT_PASSWORD, ACCOUNT_PROFILE, ACCOUNT_SETTINGS } from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function ProfileTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();

    return (
        <HeaderTabsContainer>
            <TabButton
                route={ACCOUNT_PROFILE}
                i18nCode="account.profile.personalData.tab.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={ACCOUNT_PASSWORD}
                i18nCode="account.profile.changePassword.tab.title"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={ACCOUNT_SETTINGS}
                i18nCode="react.page.title.profilesettings"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default ProfileTabs;
